import { render, staticRenderFns } from "./CategoryCover_c3.vue?vue&type=template&id=145d6563&"
import script from "./CategoryCover_c3.vue?vue&type=script&lang=js&"
export * from "./CategoryCover_c3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports